<!-- Overlay para cerrar menú en móvil -->
<div class="navbar-overlay" [class.visible]="menuAbierto" (click)="menuAbierto = false"></div>

<!-- BOTTOM NAVIGATION BAR (Solo Móvil) -->
<nav class="mobile-bottom-nav">

    <ng-container *ngIf="quickLinks$ | async as quickLinks">
        <a *ngFor="let link of quickLinks" [routerLink]="link.ruta.startsWith('/') ? link.ruta : '/' + link.ruta"
            routerLinkActive="active" class="bottom-nav-item" (click)="menuAbierto = false">
            <i class="fas" [ngClass]="link.icon || 'fa-circle'"></i>
            <span>{{ link.nombre }}</span>
        </a>
    </ng-container>

    <button class="bottom-nav-item menu-trigger" (click)="menuAbierto = !menuAbierto" [class.active]="menuAbierto">
        <i class="fas" [ngClass]="menuAbierto ? 'fa-times' : 'fa-bars'"></i>
        <span>Menú</span>
    </button>
</nav>

<header class="navbar-institutional" [class.expanded]="menuAbierto">
    <nav class="navbar-container">

        <!-- Logo y título institucional -->
        <div class="institutional-header">
            <div class="logo-container">
                <img src="../../assets/img/musachi.png" alt="Logo" class="institution-logo">
            </div>
            <div class="institution-info" [class.visible]="menuAbierto">
                <h3 class="institution-name">cris7ianback</h3>
            </div>
        </div>

        <!-- El menú principal estaba aquí -->

        <!-- Menú principal de navegación -->
        <div class="navbar-navigation" [class.open]="menuAbierto">
            <div *ngFor="let categoria of menu$ | async; trackBy: trackByCategory" class="nav-category">
                <button class="nav-category-header" type="button" (click)="categoria.abierto = !categoria.abierto"
                    [attr.aria-expanded]="categoria.abierto" [attr.aria-controls]="'submenu-' + categoria.nombre">
                    <div class="category-icon">
                        <i class="fas" [ngClass]="categoria.icono || 'fa-folder'"></i>
                    </div>
                    <span class="category-title">{{ categoria.nombre }}</span>
                    <i class="fas fa-chevron-down chevron-indicator" [class.rotated]="categoria.abierto"
                        aria-hidden="true"></i>
                </button>

                <div *ngIf="categoria.abierto" class="nav-submenu" [id]="'submenu-' + categoria.nombre" role="menu">
                    <a *ngFor="let ruta of categoria.rutas; trackBy: trackByRoute" class="nav-link"
                        [routerLink]="ruta.ruta.startsWith('/') ? ruta.ruta : '/' + ruta.ruta"
                        routerLinkActive="active-link" (click)="menuAbierto = false" role="menuitem">
                        <div class="link-icon">
                            <i class="fas" [ngClass]="ruta.icon || 'fa-circle'"></i>
                        </div>
                        <span class="link-title">{{ ruta.nombre }}</span>
                    </a>
                </div>
            </div>
        </div>

        <!-- Panel de usuario y configuración -->
        <div class="navbar-user-panel">
            <!-- Toggle de tema -->
            <div class="theme-toggle-container">
                <label for="themeToggle" class="theme-toggle-wrapper" title="Cambiar tema">
                    <input type="checkbox" id="themeToggle" class="theme-input" [checked]="themeService.isDark()"
                        (change)="themeService.toggleTheme()" aria-label="Alternar tema claro/oscuro" />
                    <div class="theme-switch">
                        <svg class="theme-icon" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                            <mask id="moon-mask">
                                <rect x="0" y="0" width="20" height="20" fill="white"></rect>
                                <circle cx="11" cy="3" r="8" fill="black"></circle>
                            </mask>
                            <circle class="sun-moon" cx="10" cy="10" r="8" mask="url(#moon-mask)"></circle>
                            <g class="sun-rays">
                                <circle class="sun-ray ray-1" cx="18" cy="10" r="1.5"></circle>
                                <circle class="sun-ray ray-2" cx="14" cy="16.928" r="1.5"></circle>
                                <circle class="sun-ray ray-3" cx="6" cy="16.928" r="1.5"></circle>
                                <circle class="sun-ray ray-4" cx="2" cy="10" r="1.5"></circle>
                                <circle class="sun-ray ray-5" cx="6" cy="3.1718" r="1.5"></circle>
                                <circle class="sun-ray ray-6" cx="14" cy="3.1718" r="1.5"></circle>
                            </g>
                        </svg>
                    </div>
                </label>
            </div>

            <!-- Botón de perfil -->
            <a (click)="openProfile(); $event.preventDefault()" class="profile-button" title="Mi Perfil"
                style="cursor: pointer;">
                <div class="profile-icon">
                    <i class="fas fa-user"></i>
                </div>
                <span class="profile-text">Mi Perfil</span>
            </a>

            <!-- Botón de cerrar sesión -->
            <button (click)="logout(); $event.preventDefault()" class="logout-button" title="Cerrar sesión"
                aria-label="Cerrar sesión">
                <div class="logout-icon">
                    <i class="fas fa-sign-out-alt"></i>
                </div>
                <span class="logout-text">Cerrar Sesión</span>
            </button>
        </div>

    </nav>
</header>